export default "__VITE_ASSET__B72Os2k8__"